import React, { useState, useEffect, useRef } from 'react';
import cl from './Style.module.css';
import { Link } from 'react-router-dom';
import { useLoader } from '../../hooks/useLoader';
import AdminService from '../../API/AdminService';
import { useNavigate } from 'react-router-dom';
import logger from '../../utils/logger';
import PageIntro from '../../components/PageIntro/PageIntro';
import {
    IconPays, IconPlus, IconSearch, IconChevronUp, IconChevronDown,
} from '../../components/Icons';

// Иконка-индикатор направления сортировки колонки таблицы — SVG-стрелки.
function SortIcon({ active, dir }) {
    if (!active) {
        return (
            <span style={{
                display: 'inline-flex',
                flexDirection: 'column',
                marginLeft: 4,
                color: 'var(--sk-content-text-muted)',
                opacity: 0.6,
            }}>
                <IconChevronUp width={9} height={9}/>
                <IconChevronDown width={9} height={9} style={{ marginTop: -2 }}/>
            </span>
        );
    }
    return (
        <span style={{ display: 'inline-flex', marginLeft: 4, color: '#b08620' }}>
            {dir === 'asc' ? <IconChevronUp width={12} height={12}/> : <IconChevronDown width={12} height={12}/>}
        </span>
    );
}
const Pays = () => {
    const navigate = useNavigate();
    const [pays, setPays] = useState([]);
    const [students, setStudents] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredPays, setFilteredPays] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [editingPay, setEditingPay] = useState(null);

    // Состояния для поиска студентов в создании
    const [studentSearchMethod, setStudentSearchMethod] = useState('search'); // 'search' или 'select'
    const [studentSearchTerm, setStudentSearchTerm] = useState('');
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [showStudentSuggestions, setShowStudentSuggestions] = useState(false);

    // Состояния для поиска студентов в редактировании
    const [editStudentSearchMethod, setEditStudentSearchMethod] = useState('select');
    const [editStudentSearchTerm, setEditStudentSearchTerm] = useState('');
    const [editFilteredStudents, setEditFilteredStudents] = useState([]);
    const [showEditStudentSuggestions, setShowEditStudentSuggestions] = useState(false);

    // Состояние сортировки
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const [newPay, setNewPay] = useState({
        idStudent: '',
        date: new Date().toISOString().split('T')[0],
        price: '',
        comment: '',
        typePay: 'Наличные'
    });

    const [editPay, setEditPay] = useState({
        idStudent: '',
        date: '',
        price: '',
        comment: '',
        typePay: 'Наличные'
    });

    // Ref для контейнера подсказок
    const suggestionsRef = useRef(null);
    const editSuggestionsRef = useRef(null);

    // Загрузка платежей
    const [fetchPays, isLoading, error] = useLoader(async () => {
        try {
            const response = await AdminService.getAllPays();
            setPays(response.data || []);
            setFilteredPays(response.data || []);
        } catch (error) {
            logger.error('Ошибка загрузки платежей:', error);
        }
    });

    // Загрузка студентов
    const [fetchStudents, isLoadingStudents] = useLoader(async () => {
        try {
            const response = await AdminService.getAllStudents();
            setStudents(response.data || []);
        } catch (error) {
            logger.error('Ошибка загрузки студентов:', error);
        }
    });

    // Создание нового платежа
    const [createPay, isCreating, createError] = useLoader(async () => {
        try {
            const payData = {
                ...newPay,
                idStudent: parseInt(newPay.idStudent),
                price: parseInt(newPay.price)
            };
            const response = await AdminService.createPay(payData);
            if (response.data) {
                setPays(prev => [...prev, response.data]);
                setFilteredPays(prev => [...prev, response.data]);
                setShowModal(false);
                resetModalForm();
            }
        } catch (error) {
            logger.error('Ошибка создания платежа:', error);
        }
    });

    // Обновление платежа
    const [updatePay, isUpdating, updateError] = useLoader(async () => {
        try {
            const payData = {
                ...editPay,
                idStudent: parseInt(editPay.idStudent),
                price: parseInt(editPay.price)
            };
            const response = await AdminService.updatePay(editingPay.id, payData);
            if (response.data) {
                setPays(prev => prev.map(pay =>
                    pay.id === editingPay.id ? response.data : pay
                ));
                setFilteredPays(prev => prev.map(pay =>
                    pay.id === editingPay.id ? response.data : pay
                ));
                setShowEditModal(false);
                setEditingPay(null);
                resetEditModalForm();
            }
        } catch (error) {
            logger.error('Ошибка обновления платежа:', error);
        }
    });

    // Удаление платежа
    const [deletePay, isDeleting, deleteError] = useLoader(async () => {
        try {
            await AdminService.deletePay(editingPay.id);
            setPays(prev => prev.filter(pay => pay.id !== editingPay.id));
            setFilteredPays(prev => prev.filter(pay => pay.id !== editingPay.id));
            setShowDeleteModal(false);
            setShowEditModal(false);
            setEditingPay(null);
            resetEditModalForm();
        } catch (error) {
            logger.error('Ошибка удаления платежа:', error);
        }
    });

    // Сброс формы создания
    const resetModalForm = () => {
        setNewPay({
            idStudent: '',
            date: new Date().toISOString().split('T')[0],
            price: '',
            comment: '',
            typePay: 'Наличные'
        });
        setStudentSearchMethod('search');
        setStudentSearchTerm('');
        setFilteredStudents([]);
        setShowStudentSuggestions(false);
    };

    // Сброс формы редактирования
    const resetEditModalForm = () => {
        setEditPay({
            idStudent: '',
            date: '',
            price: '',
            comment: '',
            typePay: 'Наличные'
        });
        setEditStudentSearchMethod('select');
        setEditStudentSearchTerm('');
        setEditFilteredStudents([]);
        setShowEditStudentSuggestions(false);
    };

    // Открытие модалки редактирования
    const openEditModal = (pay) => {
        setEditingPay(pay);
        const student = students.find(s => s.id === pay.idStudent);
        setEditPay({
            idStudent: pay.idStudent,
            date: pay.date,
            price: pay.price,
            comment: pay.comment || '',
            typePay: pay.typePay || 'Наличные'
        });
        if (student) {
            setEditStudentSearchTerm(`${student.ferstName} ${student.lastName}`);
        }
        setShowEditModal(true);
    };

    // Загрузка данных при монтировании компонента
    useEffect(() => {
        fetchPays();
        fetchStudents();
    }, []);

    // Фильтрация студентов для поиска (создание)
    useEffect(() => {
        if (studentSearchTerm.length > 0) {
            const filtered = students.filter(student => {
                const fullName = `${student.ferstName} ${student.lastName}`.toLowerCase();
                return fullName.includes(studentSearchTerm.toLowerCase());
            });
            setFilteredStudents(filtered);
            setShowStudentSuggestions(true);
        } else {
            setFilteredStudents([]);
            setShowStudentSuggestions(false);
        }
    }, [studentSearchTerm, students]);

    // Фильтрация студентов для поиска (редактирование)
    useEffect(() => {
        if (editStudentSearchTerm.length > 0 && editStudentSearchMethod === 'search') {
            const filtered = students.filter(student => {
                const fullName = `${student.ferstName} ${student.lastName}`.toLowerCase();
                return fullName.includes(editStudentSearchTerm.toLowerCase());
            });
            setEditFilteredStudents(filtered);
            setShowEditStudentSuggestions(true);
        } else {
            setEditFilteredStudents([]);
            setShowEditStudentSuggestions(false);
        }
    }, [editStudentSearchTerm, students, editStudentSearchMethod]);

    // Фильтрация платежей по поисковому запросу
    useEffect(() => {
        if (!searchTerm) {
            setFilteredPays(pays);
            return;
        }

        const filtered = pays.filter(pay => {
            const searchLower = searchTerm.toLowerCase();
            const student = students.find(s => s.id === pay.idStudent);
            const studentName = student ? `${student.ferstName} ${student.lastName}` : '';

            return (
                pay.id?.toString().toLowerCase().includes(searchLower) ||
                studentName.toLowerCase().includes(searchLower) ||
                pay.date?.toLowerCase().includes(searchLower) ||
                pay.price?.toString().toLowerCase().includes(searchLower) ||
                pay.comment?.toLowerCase().includes(searchLower) ||
                pay.typePay?.toLowerCase().includes(searchLower)
            );
        });
        setFilteredPays(filtered);
    }, [searchTerm, pays, students]);

    // Закрытие подсказок при клике вне контейнера
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (suggestionsRef.current && !suggestionsRef.current.contains(event.target)) {
                setShowStudentSuggestions(false);
            }
            if (editSuggestionsRef.current && !editSuggestionsRef.current.contains(event.target)) {
                setShowEditStudentSuggestions(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Функция сортировки
    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });

        const sortedPays = [...filteredPays].sort((a, b) => {
            let aValue = a[key];
            let bValue = b[key];

            // Особая обработка для поля студента
            if (key === 'student') {
                const studentA = students.find(s => s.id === a.idStudent);
                const studentB = students.find(s => s.id === b.idStudent);
                aValue = studentA ? `${studentA.ferstName} ${studentA.lastName}` : '';
                bValue = studentB ? `${studentB.ferstName} ${studentB.lastName}` : '';
            }

            // Обработка суммы как числа
            if (key === 'price') {
                aValue = parseInt(aValue) || 0;
                bValue = parseInt(bValue) || 0;
            }

            // Обработка даты
            if (key === 'date') {
                aValue = new Date(aValue || '1970-01-01');
                bValue = new Date(bValue || '1970-01-01');
            }

            if (aValue === null || aValue === undefined) aValue = '';
            if (bValue === null || bValue === undefined) bValue = '';

            if (direction === 'asc') {
                if (key === 'price' || key === 'date') {
                    return aValue - bValue;
                } else {
                    return aValue.toString().localeCompare(bValue.toString(), 'ru', { numeric: true });
                }
            } else {
                if (key === 'price' || key === 'date') {
                    return bValue - aValue;
                } else {
                    return bValue.toString().localeCompare(aValue.toString(), 'ru', { numeric: true });
                }
            }
        });
        setFilteredPays(sortedPays);
    };

    // Получение иконки сортировки
    // Иконка сортировки колонки — SVG (заменили старые ↕↑↓)
    const getSortIcon = (key) => (
        <SortIcon active={sortConfig.key === key} dir={sortConfig.direction}/>
    );

    // Получение имени студента по ID
    const getStudentName = (studentId) => {
        const student = students.find(s => s.id === studentId);
        return student ? `${student.ferstName} ${student.lastName}` : 'Неизвестный студент';
    };

    // Выбор студента из подсказок (создание)
    const handleStudentSelect = (student, event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        setNewPay(prev => ({
            ...prev,
            idStudent: student.id
        }));
        setStudentSearchTerm(`${student.ferstName} ${student.lastName}`);
        setShowStudentSuggestions(false);
    };

    // Выбор студента из подсказок (редактирование)
    const handleEditStudentSelect = (student, event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        setEditPay(prev => ({
            ...prev,
            idStudent: student.id
        }));
        setEditStudentSearchTerm(`${student.ferstName} ${student.lastName}`);
        setShowEditStudentSuggestions(false);
    };

    // Форматирование даты
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('ru-RU');
    };

    // Форматирование суммы
    const formatPrice = (price) => {
        return price ? `${price} ₽` : '0 ₽';
    };

    // Обработка отправки формы создания
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!newPay.idStudent || !newPay.price) {
            alert('Пожалуйста, заполните обязательные поля: студент и сумма');
            return;
        }
        createPay();
    };

    // Обработка отправки формы редактирования
    const handleEditSubmit = (e) => {
        e.preventDefault();
        if (!editPay.idStudent || !editPay.price) {
            alert('Пожалуйста, заполните обязательные поля: студент и сумма');
            return;
        }
        updatePay();
    };

    // Обработка клика по строке таблицы
    const handleRowClick = (pay) => {
        openEditModal(pay);
    };

    // Открытие модалки подтверждения удаления
    const handleDeleteConfirm = () => {
        setShowDeleteModal(true);
    };

    // Подтверждение удаления
    const handleDeleteExecute = () => {
        deletePay();
    };

    // Отмена удаления
    const handleDeleteCancel = () => {
        setShowDeleteModal(false);
    };

    if (isLoading || isLoadingStudents) {
        return (
            <div className={cl.page_wrapper}>
                <div className={cl.wrap_content_1}>
                    <div className={cl.loading}>Загрузка...</div>
                </div>
            </div>
        );
    }

    return (
        <div className={cl.page_wrapper}>
            <div className={cl.wrap_content_1}>






                {/* Карточка-шапка раздела */}
                <div className={cl.pageHeader}>
                    <div className={cl.pageHeaderLeft}>
                        <div className={cl.pageHeaderIcon}>
                            <IconPays width={22} height={22}/>
                        </div>
                        <div className={cl.pageHeaderText}>
                            <div className={cl.pageHeaderTopRow}>
                                <h1 className={cl.pageHeaderTitle}>Платежи</h1>
                                <span className={cl.pageHeaderPill}>
                                    <span className={cl.pageHeaderPillStrong}>{filteredPays.length}</span>
                                    <span className={cl.pageHeaderPillMuted}>записей</span>
                                </span>
                                {filteredPays.length > 0 && (
                                    <span className={`${cl.pageHeaderPill} ${cl.pageHeaderPillActive}`}>
                                        <span className={cl.pageHeaderPillStrong}>
                                            {formatPrice(filteredPays.reduce((sum, pay) => sum + (pay.price || 0), 0))}
                                        </span>
                                        <span className={cl.pageHeaderPillMuted}>оплачено</span>
                                    </span>
                                )}
                            </div>
                            <div className={cl.breadcrumbs}>
                                АдминПанель · Платежи
                            </div>
                        </div>
                    </div>
                    <button
                        onClick={() => setShowModal(true)}
                        className={cl.addButton}
                        disabled={isCreating}
                    >
                        <IconPlus width={16} height={16}/>
                        <span>{isCreating ? 'Создание…' : 'Новый платёж'}</span>
                    </button>
                </div>

                <PageIntro
                    storageKey="pays"
                    title="О странице «Платежи»"
                    text="Все денежные операции центра: оплаты учеников за курсы и мероприятия, возвраты, прочие поступления. Сюда можно завести как фактический приход, так и плановый — для прогноза и сверки."
                    bullets={[
                        '«Новый платёж» — добавить запись об оплате, в т.ч. за конкретного ученика и курс',
                        'Сортировка и поиск работают по всем колонкам (ученик, курс, дата, сумма)',
                        'Карточка ученика и журнал курса тоже показывают связанные платежи',
                        'Сумма платежей по фильтру отображается в шапке странички',
                    ]}
                />

                {/* Поиск с иконкой */}
                <div className={cl.searchContainer}>
                    <span className={cl.searchIcon}>
                        <IconSearch width={18} height={18}/>
                    </span>
                    <input
                        type="text"
                        placeholder="Поиск по платежам…"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className={cl.searchInput}
                    />
                </div>

                {/* Таблица платежей */}
                <div className={cl.tableContainer}>
                    {filteredPays.length === 0 ? (
                        <div className={cl.noData}>
                            {pays.length === 0 ? 'Пока нет платежей' : 'Платежи не найдены'}
                        </div>
                    ) : (
                        <table className={cl.table}>
                            <thead>
                                <tr>
                                    <th
                                        onClick={() => handleSort('id')}
                                        className={cl.sortableHeader}
                                    >
                                        №{getSortIcon('id')}
                                    </th>
                                    <th
                                        onClick={() => handleSort('student')}
                                        className={cl.sortableHeader}
                                    >
                                        Студент{getSortIcon('student')}
                                    </th>
                                    <th
                                        onClick={() => handleSort('date')}
                                        className={cl.sortableHeader}
                                    >
                                        Дата оплаты{getSortIcon('date')}
                                    </th>
                                    <th
                                        onClick={() => handleSort('price')}
                                        className={cl.sortableHeader}
                                    >
                                        Сумма{getSortIcon('price')}
                                    </th>
                                    <th
                                        onClick={() => handleSort('typePay')}
                                        className={cl.sortableHeader}
                                    >
                                        Тип оплаты{getSortIcon('typePay')}
                                    </th>
                                    <th
                                        onClick={() => handleSort('comment')}
                                        className={cl.sortableHeader}
                                    >
                                        Комментарий{getSortIcon('comment')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredPays.map((pay, index) => (
                                    <tr
                                        key={pay.id}
                                        className={cl.tableRow}
                                        onClick={() => handleRowClick(pay)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <td className={cl.tableCell} data-label="№">{pay.id}</td>
                                        <td className={cl.tableCell} data-label="Студент">
                                            <div className={cl.studentInfo}>
                                                {getStudentName(pay.idStudent)}
                                            </div>
                                        </td>
                                        <td className={cl.tableCell} data-label="Дата">
                                            {formatDate(pay.date)}
                                        </td>
                                        <td className={cl.tableCell} data-label="Сумма">
                                            <span className={cl.priceAmount}>
                                                {formatPrice(pay.price)}
                                            </span>
                                        </td>
                                        <td className={cl.tableCell} data-label="Тип">
                                            <span className={cl.payType}>
                                                {pay.typePay || '-'}
                                            </span>
                                        </td>
                                        <td className={cl.tableCell} data-label="Комментарий">
                                            <div className={cl.comment}>
                                                {pay.comment || '-'}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>

                {/* Модальное окно добавления платежа */}
                {showModal && (
                    <div className={cl.modalOverlay} onClick={() => setShowModal(false)}>
                        <div className={cl.modal} onClick={(e) => e.stopPropagation()}>
                            <div className={cl.modalHeader}>
                                <h2>Новый платеж</h2>
                                <button
                                    className={cl.modalClose}
                                    onClick={() => setShowModal(false)}
                                >
                                    ×
                                </button>
                            </div>

                            <form onSubmit={handleSubmit} className={cl.modalForm}>
                                {/* Выбор способа поиска студента */}
                                <div className={cl.formGroup}>
                                    <label className={cl.label}>
                                        Студент <span className={cl.required}>*</span>
                                    </label>

                                    <div className={cl.studentSearchMethods}>
                                        <label className={cl.radioLabel}>
                                            <input
                                                type="radio"
                                                name="studentSearchMethod"
                                                value="search"
                                                checked={studentSearchMethod === 'search'}
                                                onChange={(e) => {
                                                    setStudentSearchMethod(e.target.value);
                                                    if (e.target.value === 'search') {
                                                        setNewPay(prev => ({ ...prev, idStudent: '' }));
                                                    }
                                                }}
                                                className={cl.radioInput}
                                            />
                                            <span>Введите фамилию для поиска</span>
                                        </label>

                                        <label className={cl.radioLabel}>
                                            <input
                                                type="radio"
                                                name="studentSearchMethod"
                                                value="select"
                                                checked={studentSearchMethod === 'select'}
                                                onChange={(e) => {
                                                    setStudentSearchMethod(e.target.value);
                                                    if (e.target.value === 'select') {
                                                        setStudentSearchTerm('');
                                                        setShowStudentSuggestions(false);
                                                    }
                                                }}
                                                className={cl.radioInput}
                                            />
                                            <span>Найти ученика в списке</span>
                                        </label>
                                    </div>

                                    {/* Поиск по фамилии */}
                                    {studentSearchMethod === 'search' && (
                                        <div className={cl.studentSearchContainer} ref={suggestionsRef}>
                                            <input
                                                type="text"
                                                value={studentSearchTerm}
                                                onChange={(e) => setStudentSearchTerm(e.target.value)}
                                                placeholder="Начните вводить фамилию..."
                                                className={cl.input}
                                                autoComplete="off"
                                            />

                                            {/* Подсказки */}
                                            {showStudentSuggestions && filteredStudents.length > 0 && (
                                                <div className={cl.studentSuggestions}>
                                                    {filteredStudents.map(student => (
                                                        <div
                                                            key={student.id}
                                                            className={cl.studentSuggestion}
                                                            onMouseDown={() => handleStudentSelect(student)}
                                                        >
                                                            <div className={cl.suggestionName}>
                                                                {student.ferstName} {student.lastName}
                                                            </div>
                                                            <div className={cl.suggestionDetails}>
                                                                {student.age} лет
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            {showStudentSuggestions && filteredStudents.length === 0 && studentSearchTerm && (
                                                <div className={cl.noSuggestions}>
                                                    Студенты не найдены
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {/* Выпадающий список */}
                                    {studentSearchMethod === 'select' && (
                                        <select
                                            value={newPay.idStudent}
                                            onChange={(e) => setNewPay(prev => ({
                                                ...prev,
                                                idStudent: e.target.value
                                            }))}
                                            className={cl.input}
                                            required
                                        >
                                            <option value="">Выберите студента</option>
                                            {students.map(student => (
                                                <option key={student.id} value={student.id}>
                                                    {student.ferstName} {student.lastName}
                                                </option>
                                            ))}
                                        </select>
                                    )}
                                </div>

                                <div className={cl.formRow}>
                                    <div className={cl.formGroup}>
                                        <label className={cl.label}>
                                            Дата оплаты <span className={cl.required}>*</span>
                                        </label>
                                        <input
                                            type="date"
                                            value={newPay.date}
                                            onChange={(e) => setNewPay(prev => ({
                                                ...prev,
                                                date: e.target.value
                                            }))}
                                            className={cl.input}
                                            required
                                        />
                                    </div>

                                    <div className={cl.formGroup}>
                                        <label className={cl.label}>
                                            Сумма (₽) <span className={cl.required}>*</span>
                                        </label>
                                        <input
                                            type="number"
                                            value={newPay.price}
                                            onChange={(e) => setNewPay(prev => ({
                                                ...prev,
                                                price: e.target.value
                                            }))}
                                            className={cl.input}
                                            min="0"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className={cl.formGroup}>
                                    <label className={cl.label}>Тип оплаты</label>
                                    <select
                                        value={newPay.typePay}
                                        onChange={(e) => setNewPay(prev => ({
                                            ...prev,
                                            typePay: e.target.value
                                        }))}
                                        className={cl.input}
                                    >
                                        <option value="Наличные">Наличные</option>
                                        <option value="Перевод">Перевод</option>
                                        <option value="Карта">Карта</option>
                                        <option value="СБП">СБП</option>
                                    </select>
                                </div>

                                <div className={cl.formGroup}>
                                    <label className={cl.label}>Комментарий</label>
                                    <textarea
                                        value={newPay.comment}
                                        onChange={(e) => setNewPay(prev => ({
                                            ...prev,
                                            comment: e.target.value
                                        }))}
                                        className={cl.textarea}
                                        rows="3"
                                        placeholder="Дополнительная информация о платеже..."
                                    />
                                </div>

                                <div className={cl.modalActions}>
                                    <button
                                        type="button"
                                        className={cl.buttonSecondary}
                                        onClick={() => setShowModal(false)}
                                    >
                                        Отменить
                                    </button>
                                    <button
                                        type="submit"
                                        className={cl.buttonPrimary}
                                        disabled={isCreating}
                                    >
                                        {isCreating ? 'Создание...' : 'Создать платеж'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {/* Модальное окно редактирования платежа */}
                {showEditModal && (
                    <div className={cl.modalOverlay} onClick={() => setShowEditModal(false)}>
                        <div className={cl.modal} onClick={(e) => e.stopPropagation()}>
                            <div className={cl.modalHeader}>
                                <h2>Редактировать платеж #{editingPay?.id}</h2>
                                <button
                                    className={cl.modalClose}
                                    onClick={() => setShowEditModal(false)}
                                >
                                    ×
                                </button>
                            </div>

                            <form onSubmit={handleEditSubmit} className={cl.modalForm}>
                                {/* Выбор способа поиска студента */}
                                <div className={cl.formGroup}>
                                    <label className={cl.label}>
                                        Студент <span className={cl.required}>*</span>
                                    </label>

                                    <div className={cl.studentSearchMethods}>
                                        <label className={cl.radioLabel}>
                                            <input
                                                type="radio"
                                                name="editStudentSearchMethod"
                                                value="search"
                                                checked={editStudentSearchMethod === 'search'}
                                                onChange={(e) => {
                                                    setEditStudentSearchMethod(e.target.value);
                                                    if (e.target.value === 'search') {
                                                        setEditStudentSearchTerm('');
                                                    }
                                                }}
                                                className={cl.radioInput}
                                            />
                                            <span>Поиск по фамилии</span>
                                        </label>

                                        <label className={cl.radioLabel}>
                                            <input
                                                type="radio"
                                                name="editStudentSearchMethod"
                                                value="select"
                                                checked={editStudentSearchMethod === 'select'}
                                                onChange={(e) => {
                                                    setEditStudentSearchMethod(e.target.value);
                                                    if (e.target.value === 'select') {
                                                        setEditStudentSearchTerm('');
                                                        setShowEditStudentSuggestions(false);
                                                    }
                                                }}
                                                className={cl.radioInput}
                                            />
                                            <span>Выбрать из списка</span>
                                        </label>
                                    </div>

                                    {/* Поиск по фамилии */}
                                    {editStudentSearchMethod === 'search' && (
                                        <div className={cl.studentSearchContainer} ref={editSuggestionsRef}>
                                            <input
                                                type="text"
                                                value={editStudentSearchTerm}
                                                onChange={(e) => setEditStudentSearchTerm(e.target.value)}
                                                placeholder="Начните вводить фамилию..."
                                                className={cl.input}
                                                autoComplete="off"
                                            />

                                            {/* Подсказки */}
                                            {showEditStudentSuggestions && editFilteredStudents.length > 0 && (
                                                <div className={cl.studentSuggestions}>
                                                    {editFilteredStudents.map(student => (
                                                        <div
                                                            key={student.id}
                                                            className={cl.studentSuggestion}
                                                            onMouseDown={(e) => handleEditStudentSelect(student, e)}
                                                        >
                                                            <div className={cl.suggestionName}>
                                                                {student.ferstName} {student.lastName}
                                                            </div>
                                                            <div className={cl.suggestionDetails}>
                                                                {student.age} лет
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            {showEditStudentSuggestions && editFilteredStudents.length === 0 && editStudentSearchTerm && (
                                                <div className={cl.noSuggestions}>
                                                    Студенты не найдены
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {/* Выпадающий список */}
                                    {editStudentSearchMethod === 'select' && (
                                        <select
                                            value={editPay.idStudent}
                                            onChange={(e) => setEditPay(prev => ({
                                                ...prev,
                                                idStudent: e.target.value
                                            }))}
                                            className={cl.input}
                                            required
                                        >
                                            <option value="">Выберите студента</option>
                                            {students.map(student => (
                                                <option key={student.id} value={student.id}>
                                                    {student.ferstName} {student.lastName}
                                                </option>
                                            ))}
                                        </select>
                                    )}
                                </div>

                                <div className={cl.formRow}>
                                    <div className={cl.formGroup}>
                                        <label className={cl.label}>
                                            Дата оплаты <span className={cl.required}>*</span>
                                        </label>
                                        <input
                                            type="date"
                                            value={editPay.date}
                                            onChange={(e) => setEditPay(prev => ({
                                                ...prev,
                                                date: e.target.value
                                            }))}
                                            className={cl.input}
                                            required
                                        />
                                    </div>

                                    <div className={cl.formGroup}>
                                        <label className={cl.label}>
                                            Сумма (₽) <span className={cl.required}>*</span>
                                        </label>
                                        <input
                                            type="number"
                                            value={editPay.price}
                                            onChange={(e) => setEditPay(prev => ({
                                                ...prev,
                                                price: e.target.value
                                            }))}
                                            className={cl.input}
                                            min="0"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className={cl.formGroup}>
                                    <label className={cl.label}>Тип оплаты</label>
                                    <select
                                        value={editPay.typePay}
                                        onChange={(e) => setEditPay(prev => ({
                                            ...prev,
                                            typePay: e.target.value
                                        }))}
                                        className={cl.input}
                                    >
                                        <option value="Наличные">Наличные</option>
                                        <option value="Перевод">Перевод</option>
                                        <option value="Карта">Карта</option>
                                        <option value="СБП">СБП</option>
                                    </select>
                                </div>

                                <div className={cl.formGroup}>
                                    <label className={cl.label}>Комментарий</label>
                                    <textarea
                                        value={editPay.comment}
                                        onChange={(e) => setEditPay(prev => ({
                                            ...prev,
                                            comment: e.target.value
                                        }))}
                                        className={cl.textarea}
                                        rows="3"
                                        placeholder="Дополнительная информация о платеже..."
                                    />
                                </div>

                                {/* Измененные действия модалки - убрали "Отменить" */}
                                <div className={cl.modalActions}>
                                    <button
                                        type="button"
                                        className={cl.buttonDanger}
                                        onClick={handleDeleteConfirm}
                                        disabled={isDeleting}
                                    >
                                        Удалить платеж
                                    </button>
                                    <button
                                        type="submit"
                                        className={cl.buttonPrimary}
                                        disabled={isUpdating}
                                    >
                                        {isUpdating ? 'Сохранение...' : 'Сохранить изменения'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {/* Модальное окно подтверждения удаления */}
                {showDeleteModal && (
                    <div className={cl.modalOverlay} onClick={handleDeleteCancel}>
                        <div className={cl.deleteModal} onClick={(e) => e.stopPropagation()}>
                            <div className={cl.deleteModalHeader}>
                                <h3>Подтвердите удаление</h3>
                            </div>

                            <div className={cl.deleteModalBody}>
                                <p>Вы точно хотите удалить платеж?</p>
                                <p className={cl.deleteWarning}>
                                    <strong>Данные платежа нельзя будет восстановить.</strong>
                                </p>

                                {editingPay && (
                                    <div className={cl.paymentDetails}>
                                        <p><strong>Платеж:</strong> #{editingPay.id}</p>
                                        <p><strong>Студент:</strong> {getStudentName(editingPay.idStudent)}</p>
                                        <p><strong>Сумма:</strong> {formatPrice(editingPay.price)}</p>
                                        <p><strong>Дата:</strong> {formatDate(editingPay.date)}</p>
                                    </div>
                                )}
                            </div>

                            <div className={cl.deleteModalActions}>
                                <button
                                    type="button"
                                    className={cl.buttonSecondary}
                                    onClick={handleDeleteCancel}
                                >
                                    Отменить
                                </button>
                                <button
                                    type="button"
                                    className={cl.buttonDanger}
                                    onClick={handleDeleteExecute}
                                    disabled={isDeleting}
                                >
                                    {isDeleting ? 'Удаление...' : 'Да, удалить'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Отображение ошибок */}
                {error && (
                    <div className={cl.error}>
                        Ошибка загрузки: {error.message}
                    </div>
                )}
                {createError && (
                    <div className={cl.error}>
                        Ошибка создания: {createError.message}
                    </div>
                )}
                {updateError && (
                    <div className={cl.error}>
                        Ошибка обновления: {updateError.message}
                    </div>
                )}
                {deleteError && (
                    <div className={cl.error}>
                        Ошибка удаления: {deleteError.message}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Pays;